import PropTypes from 'prop-types';
import { Permissions } from 'utils/constants/permissions';

import PrivateRoute from 'app/routes/PrivateRoute';

const getUrlRedirect = (permissions) => {
    if (permissions.includes(Permissions.ViewPersonalAreaSection)) {
        window.location.href = '/new/not-found/';
        return '';
    }
    if (permissions.includes(Permissions.PermissionDenied)) {
        return '/new/forbidden/';
    }
    if (permissions.includes(Permissions.UserNotAuthorized)) {
        return '/new/login/';
    }
    return '/new/';
};

const AdminRoute = ({ component, ...props }) => (
    <PrivateRoute
        component={component}
        urlByPermissions={getUrlRedirect}
        allowingPermission={Permissions.ViewAdminSection}
        {...props}
    />
);

AdminRoute.propTypes = {
    component: PropTypes.elementType,
};

export default AdminRoute;
